'use strict';
import React from 'react';
import { DepartmentsAPI } from '../services/api';

export default function TeamOrgModal({ department, onClose }) {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [users, setUsers] = React.useState([]);
  const [employees, setEmployees] = React.useState([]);

  React.useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!department?.id) return;
      setLoading(true);
      setError(null);
      try {
        // API helpers return data objects directly (not axios responses)
        const [usersResp, empResp] = await Promise.all([
          DepartmentsAPI.users(department.id),
          DepartmentsAPI.employees(department.id)
        ]);
        if (cancelled) return;
        const usersList = usersResp?.data || usersResp?.users || usersResp?.departmentUsers || [];
        const employeesList = empResp?.employees || empResp?.data || [];
        setUsers(usersList);
        setEmployees(employeesList);
       
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load team');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [department?.id]);

  const close = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <div className="drawer-overlay" onClick={close} />
      <aside className="drawer-panel">
        <div className="drawer-header">
          <div className="drawer-title">{department?.name || 'Team'}</div>
          <button className="drawer-close" onClick={close} aria-label="Close">×</button>
        </div>
        <div className="drawer-content">
          {loading ? (
            <p style={{ fontSize: 12, color: '#6b7280' }}>Loading team…</p>
          ) : error ? (
            <div className="error-message" style={{ marginBottom: 8 }}>{error}</div>
          ) : (
            <>
             
              <section style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Employees</div>
                {users?.length ? (
                  <ul className="org-grid">
                    {users.map((u) => {
                      const isActive = u?.status === 'active' || u?.isActive === true;
                      return (
                        <li key={u.id} className="org-chip">
                          <span className={`org-status-dot ${isActive ? 'active' : 'inactive'}`} title={isActive ? 'Active' : 'Inactive'} />
                          <span className="org-name">{u.firstName} {u.lastName}</span>
                          {u.isAdmin && <span className="org-badge">Admin</span>}
                          {u.isSupervisor && <span className="org-badge">Supervisor</span>}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div style={{ fontSize: 12, color: '#6b7280' }}>No members assigned.</div>
                )}
              </section>
              <section>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Field Staff</div>
                {employees?.length ? (
                  <ul className="org-grid">
                    {employees.map((w) => {
                      const isActive = w?.status === 'active' || w?.isActive === true;
                      return (
                        <li key={w.id} className="org-chip">
                          <span className={`org-status-dot ${isActive ? 'active' : 'inactive'}`} title={isActive ? 'Active' : 'Inactive'} />
                          <span className="org-name">{w.firstName} {w.lastName}</span>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div style={{ fontSize: 12, color: '#6b7280' }}>No workers assigned.</div>
                )}
              </section>
            </>
          )}
        </div>
      </aside>
      <style>{`
        .drawer-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.28);
          z-index: 40;
        }
        .drawer-panel {
          position: fixed;
          top: 0;
          right: 0;
          height: 100%;
          width: 420px;
          max-width: 92vw;
          background: #fff;
          border-left: 1px solid #e5e7eb;
          box-shadow: -6px 0 20px rgba(2,6,23,0.06);
          z-index: 41;
          display: flex;
          flex-direction: column;
        }
        .drawer-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 14px;
          border-bottom: 1px solid #f3f4f6;
        }
        .drawer-title {
          font-size: 14px;
          font-weight: 600;
        }
        .drawer-close {
          background: transparent;
          border: none;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        }
        .drawer-content {
          padding: 12px 14px;
          overflow: auto;
        }
        .org-list { list-style: none; margin: 0; padding-left: 0; }
        .org-sublist { list-style: none; margin: 6px 0 0 14px; padding-left: 0; }
        .org-node { display: inline-flex; gap: 6px; align-items: center; }
        .org-leaf { margin: 2px 0; }
        .org-name { font-size: 12px; }
        .org-badge {
          font-size: 10px;
          background: #111827;
          color: #fff;
          border-radius: 999px;
          padding: 2px 6px;
        }
        .org-grid { display: flex; flex-wrap: wrap; gap: 6px; padding-left: 0; list-style: none; }
        .org-chip { display: inline-flex; gap: 6px; align-items: center; border: 1px solid #e5e7eb; border-radius: 999px; padding: 4px 8px; }
        .org-status-dot { width: 8px; height: 8px; border-radius: 999px; display: inline-block; }
        .org-status-dot.active { background: #16a34a; }
        .org-status-dot.inactive { background: #9ca3af; }
      `}</style>
    </>
  );
}


